import React, { useState, useEffect } from 'react';
import './TotalReviewsCounter.css';
import { getTotalReviews } from '../services/totalReviewsService';

const TotalReviewsCounter = () => {
  const [totalReviews, setTotalReviews] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTotalReviews = async () => {
      try {
        const count = await getTotalReviews();
        setTotalReviews(count);
      } catch (error) {
        console.error('Error fetching total reviews:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTotalReviews();
  }, []);

  if (loading) {
    return (
      <div className="total-reviews-counter loading">
        <div className="counter-icon">📝</div>
        <div className="counter-text">Loading...</div>
      </div>
    );
  }

  return (
    <div className="total-reviews-counter">
      <div className="counter-icon">📝</div>
      <div className="counter-text">
        <span className="counter-number">{totalReviews.toLocaleString()}</span>
        <span className="counter-label">reviews</span>
      </div>
    </div>
  );
};

export default TotalReviewsCounter;
